module.exports = __webpack_public_path__ + "assets/img/linkedin.068a9300.svg";